const PROFILE_KEY = 'IW_USER_PROFILE_V1';

export type UserProfile = {
  // lightweight demographics/preferences; stored client-side for now
  name?: string;
  role?: string;
  industry?: string;
  timezone?: string;
  goals?: string;
  constraints?: string;
  tonePreference?: 'direct' | 'gentle' | 'ruthless';
  communicationStyle?: string;
};

export function loadUserProfile(): UserProfile {
  try {
    const raw = window.localStorage?.getItem(PROFILE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed as UserProfile;
  } catch {
    return {};
  }
}

export function saveUserProfile(p: UserProfile) {
  try {
    window.localStorage?.setItem(PROFILE_KEY, JSON.stringify(p));
  } catch {
    // ignore
  }
}

/**
 * Compact string shipped to backend with decomposition requests.
 * Keep it short; it becomes part of the system prompt context.
 */
export function profileContextString(p?: UserProfile): string {
  const prof = p ?? loadUserProfile();
  const parts: string[] = [];

  const add = (k: string, v?: string) => {
    const t = (v ?? '').trim();
    if (!t) return;
    parts.push(`${k}: ${t}`);
  };

  add('name', prof.name);
  add('role', prof.role);
  add('industry', prof.industry);
  add('timezone', prof.timezone);
  add('goals', prof.goals);
  add('constraints', prof.constraints);
  add('tone', prof.tonePreference);
  add('style', prof.communicationStyle);

  return parts.join(' | ');
}
